import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i1.2
import React from 'react';
import IconWrap from '../../IconWrap';
const Core = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 4l-1.763 3.573-3.943.573 2.853 2.781-.674 3.927L12 15l3.527 1.854-.674-3.927 2.853-2.781-3.943-.573L12 6z",
        clipRule: "evenodd"
    })));
};
Core.displayName = 'Core';
export default Core;
